var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibraryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D27F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.771 15.6237C22.771 16.0739 23.1333 16.4408 23.5778 16.4408H26.8074C26.7764 16.0495 26.6181 15.6779 26.3396 15.3958L23.795 12.8187C23.5251 12.5453 23.1604 12.3795 22.771 12.3457V15.6237Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4801 9H16.0372C14.7595 9 13.6943 9.92792 13.4585 11.1528H20.4445H22.6322H22.7718V11.167C23.4623 11.2031 24.1295 11.4899 24.6182 11.9849L27.1628 14.562C27.6609 15.0664 27.9386 15.7304 27.9712 16.4399H27.9844V16.5734V18.797V27.6165C29.1938 27.3777 30.11 26.2981 30.11 24.997V11.6635C30.11 10.1943 28.9308 9 27.4801 9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5776 17.6193C22.4915 17.6193 21.6071 16.7236 21.6071 15.6237V12.3315H12.7398C11.2891 12.3315 10.1099 13.5258 10.1099 15.0029V28.3364C10.1099 29.8057 11.2891 30.9999 12.7398 30.9999H24.1904C25.6412 30.9999 26.8204 29.8057 26.8204 28.3364V17.6193H23.5776ZM18.137 25.6972H15.4706C15.085 25.6972 14.7724 25.3806 14.7724 24.9901C14.7724 24.5996 15.085 24.2829 15.4706 24.2829H18.137C18.5225 24.2829 18.8352 24.5996 18.8352 24.9901C18.8352 25.3806 18.5225 25.6972 18.137 25.6972ZM21.4604 22.4035H15.4706C15.085 22.4035 14.7724 22.0869 14.7724 21.6964C14.7724 21.3059 15.085 20.9892 15.4706 20.9892H21.4604C21.846 20.9892 22.1586 21.3059 22.1586 21.6964C22.1586 22.0869 21.846 22.4035 21.4604 22.4035Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/library-icon.6698aed4.svg";
export { ForwardRef as ReactComponent };